<template>
  <div>
    <v-layout row>
      <div v-if="
      this.headerObj.enableEmbeddedRegister === true &&
      this.getOrgDetailBasic !== null &&
      this.getOrgDetailBasic !== undefined
      ">
        <GetDetailPage v-if="this.getOrgDetailBasic.did !== undefined"
        class="hidden-xs-only"
        :data="{
          tag: this.getOrgDetailBasic.tag,
          stag: this.getOrgDetailBasic.tag,
          sdid: this.getOrgDetailBasic.did,
          size: 'flat',
          item: this.getOrgDetailBasic}"
        />
      </div>
      <div v-else>
        <v-btn :color="ui.btnColor" flat dark
        @click="goToMainPageFromRegister(headerObj.router)"
        class="hidden-xs-only">
          <v-icon left> {{ this.headerObj.icon }} </v-icon>
          {{ this.headerObj.title }}
        </v-btn>
      </div>
      <v-spacer/>
      <div v-if="false">
        <SearchReport :data="{title: 'Search Inspection and Test Results', tag: this.searchTag, dis: null}"
        v-if="this.getSearchResults[0].basic.tag !== null && this.getSearchResults[0].basic.tag === 'E8'"/>
      </div>
      <div v-if="this.getCurrentPage === '/reportlist'">
        <v-btn :color="ui.btnColor" flat dark :to="'/reportdetaillist'">
          <v-icon left> analytics </v-icon>
          detail
        </v-btn>
      </div>
      <div v-if="this.getCurrentPage === '/reportdetaillist'">
        <v-btn :color="ui.btnColor" flat dark :to="'/reportlist'">
          <v-icon left> reorder </v-icon>
          simple
        </v-btn>
      </div>
      <v-btn :color="ui.btnColor" flat dark
      v-if="headerObj.stats1Icon !== ''">
        <v-icon left> {{ this.headerObj.stats1Icon }} </v-icon>
        {{ this.headerObj.stats1Val }}
      </v-btn>
      <v-btn :color="ui.btnColor" flat dark
        v-if="headerObj.stats2Icon !== ''">
        <v-icon left> {{ this.headerObj.stats2Icon }} </v-icon>
        {{ this.headerObj.stats2Val }}
      </v-btn>
      <v-btn :color="ui.colorBlue" flat dark>
        <v-icon left :color="ui.colorBlue"> playlist_add </v-icon>
          {{this.getSearchResults.length}}
      </v-btn>
    </v-layout>
    <v-layout row class="ml-4 mr-4"
    v-if="
    this.headerObj.enableEmbeddedRegister === true &&
    this.getOrgDetailBasic !== null &&
    this.getOrgDetailBasic !== undefined
    ">
      <div :class="ui.textSubheadingBold">
        {{getOrgDetailBasic.id}} {{getOrgDetailBasic.title}}
      </div>
      <v-spacer/>
      <div :class="ui.textSubheadingBold">
        {{displayDocumentIDGTypeA(this.getDetailBasic.tag, this.getDetailBasic.idg)}}
      </div>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import GetDetailPage from "@/support/detail/components/GetDetailPage";
import SearchReport from "@/engineering/report/components/SearchReport";
import pageAccess from "@/frame/control/mixins/pageAccess.js";

export default {
  components: {
    GetDetailPage,
    SearchReport
    // BtnSpin
  },
  mixins: [
    dateFunctions,
    numberFunctions,
    apptheme,
    getList,
    pageAccess,
    displayFunctions,
    financeFunctions,
    describeDocument
  ],
  data() {
    return {
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  },
  props: {
    date: {
      type: Object
    }
  },
  methods: {
    defineID(num) {
      return this.defineIDGShortLastSix(num);
    },
    goToMainPageFromRegister(page) {
      console.log("MAIN PAGE");
      console.log(page);
      if (page === "/companydashsafety") {
        this.goToCompanyDashSafety();
      }
    }
  },
  computed: {
    ...mapGetters(["getSearchResults", "getOrgDetailBasic", "getRegisterInfo"]),
    searchReach() {
      let info = "";
      if (this.getRegisterInfo === null) {
        info = "company";
      } else if (this.getRegisterInfo.tag === "C1") {
        info = "company";
      } else if (this.getRegisterInfo.tag === "F1") {
        info = "facility";
      } else if (this.getRegisterInfo.tag === "A1") {
        info = "asset";
      } else if (this.getRegisterInfo.tag === "U1") {
        info = "user";
      } else {
        info = "undefined";
      }
      return info;
    },
    searchTag() {
      let tag = null;
      if (this.getSearchResults !== null) {
        tag = this.getSearchResults[0].basic.tag;
      }
      return tag;
    },
    headerObj() {
      // DEFINE
      let obj = {
        enableEmbeddedRegister: true,
        router: "userdash",
        icon: "home",
        title: "Home Page",
        stats1Icon: "",
        stats1Val: "",
        stats2Icon: "",
        stats2Val: ""
      };
      // CHECK
      // let tag = this.getSearchResults[0].basic.tag;
      // let results = this.getSearchResults;
      if (this.getRegisterInfo !== null) {
        if (this.getRegisterInfo.dis === "Electrical") {
          obj.title = "Electrical Results";
          obj.icon = "bolt";
          obj.router = "/facilitydashengineering";
        } else if (this.getRegisterInfo.dis === "Mechanical") {
          obj.title = "Mechanical Results";
          obj.icon = "attractions";
          obj.router = "/facilitydashengineering";
        } else if (this.getRegisterInfo.dis === "Process") {
          obj.title = "Process Results";
          obj.icon = "water_drop";
          obj.router = "/facilitydashengineering";
        } else {
          obj.title = "Inspection and Tests";
          obj.icon = "add_chart";
          obj.router = "/facilitydashengineering";
        }
      } else {
        obj.title = "Inspection and Tests";
        obj.icon = "add_chart";
        obj.router = "/facilitydashengineering";
      }
      return obj;
    }
  }
};
</script>
